import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { ObservationAuthoringLauncher } from "../app/observationAuthoringRoute";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/observations")({
  component: ObservationsRoute,
});

function ObservationsRoute(): JSX.Element {
  const search = Route.useSearch();
  return (
    <>
      <ObservationAuthoringLauncher search={search} />
      <PlaneRoutePage kindId="observations" search={search} />
    </>
  );
}
